import { AjaxService } from "../Helpers/AjaxService";
import { AccountStatementYear } from "../Models/Economy/AccountStatementYear";
import { forEach } from "../../../node_modules/@types/lodash-es/index";
import { CoOpStatementYear } from "../Models/Economy/CoOpStatementYear";

export class EconomyApi {
    private static instance: EconomyApi;
    static getInstance() { return EconomyApi.instance || (EconomyApi.instance = new EconomyApi()); }

    getAccountStatements(): Promise<AccountStatementYear[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/Economy/GetAccountStatementYears`;
        return new Promise<AccountStatementYear[]>((resolve) => {
            ajaxService.getWithDataInput(apiUrl,
                null,
                (result: AccountStatementYear[]) => {
                    result.forEach(accountStatementYear => {
                        accountStatementYear.AccountStatements.forEach(accountStatement => {
                            accountStatement.PostedAt = this.getDateString(new Date(parseInt(accountStatement.PostedAt.substr(6))));
                            accountStatement.DueDate = this.getDateString(new Date(parseInt(accountStatement.DueDate.substr(6))));
                        });
                    })

                    resolve(result);
                });
        });
    }

    getCoOpStatements(): Promise<CoOpStatementYear[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/Economy/GetCoOpStatementYears`;
        return new Promise<CoOpStatementYear[]>((resolve) => {
            ajaxService.getWithDataInput(apiUrl,
                null,
                (result: CoOpStatementYear[]) => {
                    result.forEach(coOpStatementYear => {
                        coOpStatementYear.CoOpStatements.forEach(coOpStatement => {
                            coOpStatement.PostedAt = this.getDateString(new Date(parseInt(coOpStatement.PostedAt.substr(6))));
                        });
                    })

                    resolve(result);
                });
        });
    }

    private getDateString(date: Date): any {
        let mm = ("0" + (date.getMonth() + 1)).slice(-2);
        let dd = ("0" + date.getDate()).slice(-2);
        let yyyy = date.getFullYear();

        return `${dd}-${mm}-${yyyy}`;
    }
}